import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
export function MidCTA() {
  return <section className="py-12 px-4 bg-salvia-light/30" data-id="element-144">
      <div className="max-w-4xl mx-auto text-center" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-146">
          <Button href="https://profelisto.com.ar/checkouts/cn/hWNCOg5GwYP70rHqBEYNvc8I/es-ar?_r=AQAB8JGlGY26t-kNJdWlfI0WeR8ziaaQxqv1_23o15dd3Gk" className="text-lg md:text-xl py-4 px-8 shadow-lg" data-id="element-147">
            👉 BASTA DE IMPROVISAR — QUIERO MI YOGA 360
          </Button>
        </motion.div>
      </div>
    </section>;
}